var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgXsolla(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ff005b",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.797 13.191l.363.633h-.738zm0-1.484l-1.66 2.863h3.312zm0 0M11.824 18.574h-.777v-2.691h.777zm0 0M12.953 18.574h-.777v-2.691h.777zm0 0M17.29 12.484a.723.723 0 00-.72.723c0 .39.32.711.72.711.394 0 .714-.32.714-.711a.722.722 0 00-.715-.723zm0 2.22a1.5 1.5 0 01-1.505-1.497 1.501 1.501 0 013.004 0 1.5 1.5 0 01-1.5 1.496zm0 0M15.508 6.742l.77-.765-.56-.551-.757.765h-.004l-.555.551v.004l.989.984-.762.758.55.559 1.321-1.32zm0 0M10.246 6.266l-.55-.555-.954.953-.953-.953-.55.555.952.945-.953.953.551.559.953-.953.953.953.551-.559-.953-.953zm0 0",
    fill: "#fff"
  })));
}

export default SvgXsolla;